"use client";
import trackPageVisit from "@workspace/casino_pages/legacyLayer/client/optimove/trackPageVisit";
import Log from "@workspace/nextjs_utils/src/Log";
import { usePathname, useSearchParams } from "next/navigation";
import { Suspense, useEffect } from "react";

const TITLE_POLL_MS = 50;
const TITLE_TIMEOUT_MS = 500;

const PageVisitReporter = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const view = `${pathname}?${searchParams}`;

  useEffect(() => {
    const reportOnceTitled = () => {
      if (!document.title) {
        return;
      }

      stop();
      trackPageVisit(window.location.href, document.title);
    };

    const reportWithPath = () => {
      stop();
      Log.warn(
        `Optimove page visit has no document title, using the path: ${window.location.href}`,
      );
      trackPageVisit(window.location.href, pathname);
    };

    const pollId = window.setInterval(reportOnceTitled, TITLE_POLL_MS);
    const timeoutId = window.setTimeout(reportWithPath, TITLE_TIMEOUT_MS);

    const stop = () => {
      window.clearInterval(pollId);
      window.clearTimeout(timeoutId);
    };

    return stop;
  }, [view, pathname]);

  return null;
};

const OptimovePageVisit = () => (
  <Suspense fallback={null}>
    <PageVisitReporter />
  </Suspense>
);

export default OptimovePageVisit;
